import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const container = css`
  ${breakpoint.up('sm')} {
    padding: 0 ${size[28]};
  }

  ${breakpoint.down('xs')} {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
  }
`

export const payInNContainer = css`
  display: flex;
  justify-content: center;
  align-items: flex-start;

  ${breakpoint.up('smMd')} {
    align-items: center;
  }
`

export const content = css`
  width: 100%;
  padding: 0 ${size[24]};

  ${breakpoint.up('smMd')} {
    max-width: 480px;
    padding: 0;
  }
  ${breakpoint.up('xl')} {
    max-width: 25vw;
  }
`
